import type { JSX } from 'solid-js';

type BtnVariant = 'default' | 'primary' | 'hostile' | 'ghost';

interface BtnProps {
  variant?: BtnVariant;
  disabled?: boolean;
  class?: string;
  style?: JSX.CSSProperties;
  onClick?: (e: MouseEvent) => void;
  children: JSX.Element;
}

export function Btn(props: BtnProps) {
  const cls = () => {
    const variant = props.variant && props.variant !== 'default' ? props.variant : '';
    return `btn ${variant} ${props.class ?? ''}`.trim();
  };
  return (
    <button
      class={cls()}
      disabled={props.disabled}
      style={props.style}
      onClick={(e) => props.onClick?.(e)}
    >
      {props.children}
    </button>
  );
}
